<template>
    <div>
        <section class="section-hero section-shaped my-0">
            <div class="shape shape-style-1 shape-primary">
                <div class="hero-hover"></div>
            </div>
            <div class="container shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-lg-9 text-center pt-lg hero-text">

                            <p class="text-white mt-0 subtitle font-weight-bold">Machine Learning Systems</p>
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle">Introduction to Embodied Intelligence</p> -->
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle">课程代码:AIB310002</p> -->
                           
                            
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle" style="text-decoration: underline; text-decoration-thickness: 2px; text-underline-offset: 2px;">本课程Project由豆包AI助手＆豆包大模型支持</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">

            <div class="container">

                <div>
                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Course Description
                            </h4>

                            <!-- 文本内容 -->

                            <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The<strong> Machine Learning Systems (ML
                                    Sys) </strong>course focuses on the integration of algorithms, system software, and
                                hardware to build efficient and scalable machine learning services. It covers topics
                                such as the evolution of machine learning architectures, including GPUs and specialized
                                AI accelerators, and explores optimization techniques like CUDA programming, parallel
                                training, efficient inference, and model optimization. The course delves into the
                                practical challenges of large-scale neural network development, training and inference,
                                emphasizing the importance of a holistic view of communication-storage-computing
                                optimization and parallelism. Ethical considerations, including privacy, safety, and
                                sustainability, are also addressed. Through hands-on programming and project work,
                                students gain a real-world understanding of ML systems, from design to deployment, and
                                learn to create machine learning systems that are efficient, scalable, and reliable for
                                the fast-evolving and diverse AI applications.

                            </h5>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Instructor
                            </h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Li_Shang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dr. Li Shang is a Professor at the Computation and Artificial Intelligence Innovative College, Fudan University. He received his Ph.D. degree from Princeton University. He was the Deputy Director and Chief Architect of Intel Labs China, and an Associate Professor of CU Boulder (tenured). His research interests include computer systems, machine learning, VLSI & EDA, with over 180 publications, multiple best paper awards and nominations, and over 9000 citations. He was a recipient of NSF Career Award. He co-founded multiple startups, driving these companies from founding to profitability. At this moment, he is coaching a group of students to initiate a startup on always-on intelligence.
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Co-Instructor
                            </h4>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            
                            <img src="/memx-website/sys_photos/Jinlong_Hou.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            
                            <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jinlong Hou is the Technical Director of the Digital Infrastructure Department at the Institute of Intelligent Innovation. His primary research interests include computer architecture and machine learning systems. He has previously served as the AI platform leader at several renowned internet companies, including Intel, Ant Group, Tencent, Pinduoduo, and Bilibili. Dr. Hou has extensive experience in GPU and domestic AI chip development and is a Huawei Ascend MVP.
                            </h5>
                        </div>
                    </div> -->

                    <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Yuedong_Xu.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Yuedong Xu is a Professor with School of Information Science and Technology, Fudan University, China. He received the Ph.D. degree from The Chinese University of Hong Kong in 2009. From 2009 to 2012, he was a Postdoctoral fellow with INRIA Sophia Antipolis and Université d'Avignon, France. He received the French MENRT fellowship in 2009, the OKAWA Foundation research grant in 2019, and the outstanding teacher nomination award in 2022. He serves an an associate editor for IEEE Transactions on Network Science and Engineering. His areas of interests include foundation model training and inference systems, and multimedia networking. He has published a number of papers in premier conferences and journals including USENIX NSDI, ACM Mobisys, ACM CoNEXT, ACM Mobihoc, IEEE Infocom, IEEE/ACM ToN and IEEE JSAC.
                            </h5>
                        </div>
                    </div>
                    
                    
                    
                    

                    
            
                    
                    
                <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Reference materials and textbooks:
                            </h4>

                            <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Machine learning systems is a broad and rapidly evolving field. You may find a wealth of online resources available, including research papers, lecture slides, blog posts, research talks, and tutorial videos shared by the research community. <br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The following online book covers basic concepts of ML Sys. <br>
                                <strong><a href="https://mlsysbook.ai" target="_blank">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;https://mlsysbook.ai</a></strong>: Machine Learning Systems - Principles and Practices of Engineering Artificially Intelligent Systems
                            </h5>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Lecture Schedule
                            </h4>

                            <table>
                                <thead>
                                    <tr>
                                        <th>Weekly schedule</th>
                                        <th>Topic</th>
                                        <th>Paper reviews</th>
                                        <th>Guest talks</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <!-- 下载图标以及链接 -->
                                            <!-- <a href="/memx-website/ei_ppt/week1/EAI-lecture1-online.pdf"
                                                target="_blank">
                                                <span>第1周:具身智能简介</span>
                                                <img src="/memx-website/ei_photos/download.jpg" alt="下载" width=16px
                                                    height=16px>
                                            </a> -->
                                            
                                                <span>Week 1</span>
                                                
                                            
                                        </td>
                                        <td>
                                            
                                            <a href="/memx-website/sys_ppt/week1/MLSys-Lecture 1-online.pdf"
                                                target="_blank">
                                                <span>What, why and how</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a>
                                            <!-- <span>What, why and how</span> -->
                                        </td>
                                        <td>
                                            
                                        </td>
                                       
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <!-- 下载图标以及链接 -->
                                            <span>Week 2-3</span>

                                        </td>
                                        <td>
                                            
                                            <!-- <a href="/memx-website/sys_ppt/week2/MLSys-Lecture 2-CPU-online.pdf"
                                                target="_blank">
                                                <span>CPU Architecture</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a><br>
                                            <a href="/memx-website/sys_ppt/week3/MLSys-Lecture 3-GPU-online.pdf"
                                                target="_blank">
                                                <span>GPU Architecture</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>CPU Architecture</span><br>
                                            <span>GPU Architecture</span> -->
                                        </td>
                                        <td>
                                            
                                        </td>
                                        
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span>Week 4</span>

                                        </td>
                                        <td>
                                            <!-- CUDA Programming -->
                                            
                                        </td>

                                        <td>
                                            
                                            <!-- <a href="/memx-website/sys_ppt/week4/DeepSeek-paper-list.pdf"
                                                target="_blank">
                                                <span>DeepSeek Paper List </span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span>Week 5</span>

                                        </td>
                                        <td>
                                            
                                            <!-- <a href="/memx-website/sys_ppt/week5/MLSys-Lecture 5-online.pdf"
                                                target="_blank">
                                                <span>DeepSeek Technology Introduction</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>DeepSeek Technology Introduction</span> -->
                                        </td>

                                        <td>
                                            
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span>Week 6-7</span>

                                        </td>
                                        <td>
                                            <!-- <a href="/memx-website/sys_ppt/week6-7/DLCompiler.pdf"
                                                target="_blank">
                                                <span>DL Compiler</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a><br>
                                            <a href="/memx-website/sys_ppt/week6-7/Abstractions for ML Compiler - 20250403.pdf"
                                                target="_blank">
                                                <span>ML Compiler</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>DL Compiler</span><br>
                                            <span>ML Compiler</span> -->
                                        </td>

                                        <td>
                                            
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td> <span>Week 8</span></td>
                                        <td>
                                        <!-- <a href="/memx-website/sys_ppt/week8/MLSys-Lecture 8-online.pdf"
                                                target="_blank">
                                                <span>Parallel Training</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                        </a><br>
                                        <a href="/memx-website/sys_ppt/seminar/MLSys-Lecture 8-training.pdf"
                                                target="_blank">
                                                <span>Parallelization and Communication Technologies</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>Parallel Training</span><br>
                                            <span>Parallelization and Communication Technologies</span> -->
                                        </td>

                                        <td>
                                            
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td> <span>Week 9</span></td>
                                        <td>
                                           
                                            <!-- <a href="/memx-website/sys_ppt/week9/MLSys-Lecture 9-online.pdf"
                                                target="_blank">
                                                <span>Inference</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>Inference</span> -->
                                        </td>

                                        <td>
                                            
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Week 10</td>
                                        <td>
                                            <!-- Labor Day Vacation -->
                                        </td>

                                        <td>
                                           
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td> <span>Week 11-12</span></td>
                                        <td>
                                            <!-- Model Optimization -->
                                        </td>

                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td> <span>Week 13</span></td>
                                        <td>
                                            <!-- Beyond Performance -->
                                        </td>

                                        <td>
                                            
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>Week 14</td>
                                        <td>
                                            <!-- Embodied AI -->
                                        </td>

                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Week 15</td>
                                        <td>
                                             
                                             <!-- <a href="/memx-website/sys_ppt/week15/AI硬件加速器.pdf"
                                                target="_blank">
                                                <span>AI Accelerators</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                            </a> -->
                                            <!-- <span>AI Accelerators</span> -->
                                        </td>

                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Week 16</td>
                                        <td>
                                            <!-- Course projects -->
                                        </td>

                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    

                </div>

            </div>
        </section>
    </div>
</template>
<script>
export default {};

</script>
<style>
table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

tr,
th,
td {
    border: 1px solid black;
    padding: 10px;
    text-align: center;
    background-color: #e8e6e6ed;
}

th {
    text-align: center;
    font-size: 20px;
}

td {

    font-size: 18px;
}

download {
    margin-left: 5px;
    /* 设置图片与文字之间的距离 */
    width: 16px;
    /* 设置图片的宽度为16px */
    height: 16px;
    /* 设置图片的高度为12px */
}
</style>
